import VerticalTimerTabs from "segments/desktop/core-components/vertical-timer-tabs/vertical-timer-tabs";
import classnames from "classnames";
import { StyledTimerVerticalTabsComponent } from "./timer-vertical-tabs-component.scss";
import DefaultProps from "./default-props";

const TimerVerticalTabsComponent = ({ isAlignedToCenter, tabsSpace, ...rest }) => {
  return (
    <StyledTimerVerticalTabsComponent
      className={classnames("timer-vertical-tabs-component", { "center-align": isAlignedToCenter })}
      style={{ "--tab-space": tabsSpace }}
    >
      <VerticalTimerTabs {...rest} />
    </StyledTimerVerticalTabsComponent>
  );
};

TimerVerticalTabsComponent.defaultProps = DefaultProps;

export default TimerVerticalTabsComponent;
